<template>
    <section :class="wrapperClass">
        <div class="aa-funnel-grid aa-funnel-grid--reseller">
            <LoadingSpinner v-if="displayLoadingSpinner"></LoadingSpinner>
            <div v-else>
                <h1 v-html="headerText" class="steps-header"></h1>
                <div v-html="subtitleText"></div>
                <div>&nbsp;</div>
                <div v-html="legalText"></div>
                <div class="text-center cta-wrapper">
                    <ButtonCta
                        v-if="pageAttr.aarp_signin_cta"
                        :buttonConfig="ctaConfig"></ButtonCta>
                </div>
                <p v-html="faqText" class="text-center"></p>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import ButtonCta from 'atoms/ButtonCta';
    import { PICK_PLAN_URL } from 'aa/vue/constants/aaRoutes';
    import ButtonConfig from 'models/ButtonConfig';
    import { tracking } from 'services/Tracking';
    import NotificationBarModel from 'aa/vue/models/NotificationBarModel';
    import LoadingSpinner from 'atoms/LoadingSpinner';

    export default {
        name: 'Aarp',
        components: {
            ButtonCta,
            LoadingSpinner,
        },

        data() {
            return {
                authorizationError: false,
            };
        },

        computed: {
            displayLoadingSpinner() {
                return this.$route.query.authorizationCode && !this.authorizationError;
            },
            ...mapState('pageAttributes', {
                pageAttr: (state) => state.attributes,
            }),
            ...mapState('flow', {
                flow: (state) => state.config,
            }),
            ...mapState('authSuite', {
                authSuiteLoaded: (state) => state.isLoaded,
                authorizationService: (state) => state.authSuiteServices.authorizationService,
            }),
            ...mapState('user', {
                userState: (state) => state,
            }),
            wrapperClass() {
                return ['padded-container', 'reseller-landing'];
            },
            ctaConfig() {
                return new ButtonConfig({
                    displayText: this.pageAttr.aarp_signin_cta,
                    event: this.aarpSelectProvider,
                    styleClass: 'button',
                });
            },
            headerText() {
                return this.pageAttr.aarp_header_copy;
            },
            subtitleText() {
                return this.pageAttr.aarp_body_copy;
            },
            legalText() {
                return this.pageAttr.aarp_legal_copy;
            },
            faqText() {
                return this.pageAttr.aarp_faq_copy;
            },
        },

        methods: {
            aarpSelectProvider() {
                tracking.trackAction('trackPartnerActivationCtaButton', {
                    ctaText: this.ctaConfig?.displayText,
                });

                this.$store.dispatch('authSuite/selectProvider', {
                    providerCode: 'aarp',
                });

                this.authorizationService
                    .getAuthenticationUrl({
                        callbackUrl: window.location.href.split('?')[0],
                        mvpdCode: 'aarp',
                    })
                    .then((resp) => {
                        window.location.href = resp.authenticationUrl;
                    });
            },

            onAuthSuiteAuthorizationCallback(authorizationCode) {
                this.$store.dispatch('authSuite/authorizationCallback', {
                    authorizationCode,
                    authorizedResourceGroup: 'paramountplus-discount',
                    successCallback: () => {
                        window.location.href = PICK_PLAN_URL + '?promo=aarp';
                    },
                    errorCallback: () => {
                        this.authorizationError = true;
                        this.openNotification(
                            new NotificationBarModel({
                                success: false,
                                message: this.$getLocale('aarp_error_banner'),
                            }),
                        );
                    },
                });
            },
        },

        watch: {
            '$store.state.authSuite.isLoaded': {
                handler(newValue, oldValue) {
                    if (newValue) {
                        if (this.$route.query.authorizationCode) {
                            this.onAuthSuiteAuthorizationCallback(
                                this.$route.query.authorizationCode,
                            );
                        }
                    }
                },
                immediate: true,
            },
        },
    };
</script>
